import gql from "graphql-tag";

export default gql`
  mutation assignOrderCarrier($orderIds: [ID!], $carrierId: ID!) {
    assignOrderCarrier(orderIds: $orderIds, carrierId: $carrierId)
  }
`;
